import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';

import { defaultSAL6020_R01DetailDto, defaultSAL6020_R01Dto, SAL6020_R01DetailDto, SAL6020_R01HeaderDto } from './Dto_SAL6020_R01';

export interface SAL6020_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	custInput: string;
	custNm: string;
}
export interface Store_SAL6020_R01 {
	SAL6020_R01Filter: SAL6020_R01Filter;
	SAL6020_R01PastFilter: SAL6020_R01Filter;
	setSAL6020_R01Filter: (filter: Partial<Store_SAL6020_R01['SAL6020_R01Filter']>) => void;
	setSAL6020_R01PastFilter: (filter: Store_SAL6020_R01['SAL6020_R01PastFilter']) => void;

	

	// ====== 견적 리스??�??�택/?�집 ======
	SAL6020_R01List: SAL6020_R01HeaderDto[];
	setSAL6020_R01List: (dataList: SAL6020_R01HeaderDto[]) => void;

	editSAL6020_R01: SAL6020_R01HeaderDto | null;
	setEditSAL6020_R01: (editSale: SAL6020_R01HeaderDto | null) => void;

	selectedSAL6020_R01: SAL6020_R01HeaderDto | undefined;
	setSelectedSAL6020_R01: (data: SAL6020_R01HeaderDto | undefined) => void;
	initSelectedSAL6020_R01: () => void;

	// ====== ?�세(?�테?? ???�택/??�� 관�?======
	deletedSAL6020_R01DetailList: string[];
	setDeletedSAL6020_R01DetailList: (idList: string[]) => void;
	addDeletedSAL6020_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL6020_R01DetailList: (idList?: string[]) => void;

	// ====== 견적 ?�세(?�테?? ?�이??======
	SAL6020_R01DetailList: SAL6020_R01DetailDto[];
	setSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[]) => void;
	insertSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[], index?: number) => void;
	removeSAL6020_R01DetailList: (index: number) => void;
	updateSAL6020_R01DetailList: (index: number, data: SAL6020_R01DetailDto) => void;

	// ====== ?�택(?�테?? ???�택/??�� 관�?======
	selectedSAL6020_R01DetailList: string[];
	setSelectedSAL6020_R01DetailList: (idList: string[]) => void;
	addSelectedSAL6020_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL6020_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL6020_R01DetailList: () => void;

	originalSAL6020_R01DetailList: SAL6020_R01DetailDto[];
	setOriginalSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[]) => void;

	// ====== 컬럼 ?�태(그리?? ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;
	

	// ====== 초기??======
	initData: () => void;

}

export const defaultSAL6020_R01Filter : SAL6020_R01Filter = {
	compCd: '',
	dateRange: getCurrentMonthDateRange(), // ???�틸리티 ?�수 ?�용?�로 변�?
	custInput: '',
	custNm: ''
};

export const useSAL6020_R01Store = create<Store_SAL6020_R01>((set) => ({
	SAL6020_R01Filter: defaultSAL6020_R01Filter,
	SAL6020_R01PastFilter: defaultSAL6020_R01Filter,
	setSAL6020_R01Filter: (update) => set((state) => ({
		SAL6020_R01Filter: {
			...state.SAL6020_R01Filter,
			...update
		}
	})),
	setSAL6020_R01PastFilter: (filter: Store_SAL6020_R01['SAL6020_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL6020_R01PastFilter: filter
		}
	}),

	// ====== 견적 리스??�??�택/?�집 ======
	SAL6020_R01List: [],
	setSAL6020_R01List: (dataList: SAL6020_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL6020_R01List: dataList
		}
	}),

	editSAL6020_R01: defaultSAL6020_R01Dto,
	setEditSAL6020_R01: (editSale: SAL6020_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL6020_R01: editSale
		}
	}),

	selectedSAL6020_R01: undefined,
	// 매출 ???�택 ??editSales???�기??
	setSelectedSAL6020_R01: (data: SAL6020_R01HeaderDto | undefined) => set((state) => {
		let editData = null;
		if (data) {
			editData = { ...data };
		}
		return { selectedSAL6020_R01: data, editSAL6020_R01: editData, detailScrollTop: null };
	}),
	initSelectedSAL6020_R01: () => set({ selectedSAL6020_R01: undefined, editSAL6020_R01: defaultSAL6020_R01Dto, SAL6020_R01DetailList: [] }),

	// ====== 견적 ?�세(?�테?? ?�이??======
	SAL6020_R01DetailList: [],
	setSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
			SAL6020_R01DetailList: newList
		};
	}),
	insertSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[], index?: number) => set((state) => {
		const newSAL6020_R01DetailList = [...state.SAL6020_R01DetailList];

		//let valueIndex = newSYS4100_R01List.length + 1;
		let valueIndex = Math.max(0, ...newSAL6020_R01DetailList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같�? orderIndex�?가�??�들 중에??가????orderIndexSeq 값을 찾는??
		const maxOrderIndexSeq = Math.max(0, ...newSAL6020_R01DetailList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('newSAL6010_R01DetailList : ', newSAL6010_R01DetailList);
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
		const newData = data.map(item => ({ ...defaultSAL6020_R01DetailDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL6020_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL6020_R01DetailList.push(...newData);
		}
		return {
			...state,
			SAL6020_R01DetailList: newSAL6020_R01DetailList
		}
	}),
	removeSAL6020_R01DetailList: (index: number) => set((state) => {
		const newSAL6020_R01DetailList = [...state.SAL6020_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL6020_R01DetailList: newSAL6020_R01DetailList
		}
	}),
	updateSAL6020_R01DetailList: (valueIndex: number, data: SAL6020_R01DetailDto) => set((state) => {
		const _SAL6020_R01DetailList = state.SAL6020_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SAL6020_R01DetailList: _SAL6020_R01DetailList
		}
	}),
	
	// ====== 행삭제 테이블(품목테이블)======
	deletedSAL6020_R01DetailList: [],
	setDeletedSAL6020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL6020_R01DetailList: idList
		}
	}),
	addDeletedSAL6020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL6020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SAL6020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SAL6020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedSAL6020_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL6020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL6020_R01DetailList: [...state.deletedSAL6020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedSAL6020_R01DetailList: [],
	setSelectedSAL6020_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL6010_R01DetailList: idList
		}
	}),
	addSelectedSAL6020_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL6020_R01DetailList = [...state.selectedSAL6020_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL6020_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL6020_R01DetailList: _selectedSAL6020_R01DetailList
		}
	}),
	removeSelectedSAL6020_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL6020_R01DetailList: [...state.selectedSAL6020_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL6020_R01DetailList: () => set({ selectedSAL6020_R01DetailList: [] }),

	originalSAL6020_R01DetailList: [],
	setOriginalSAL6020_R01DetailList: (data: SAL6020_R01DetailDto[]) => set((state) => {
		let newList: SAL6020_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL6020_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL6020_R01DetailList: newList
		}
	}),

	// ====== 컬럼 ?�태(그리?? ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
						

	// ====== 초기화======
	initData: () => set((state) => ({
		...state,
		SAL6020_R01Filter: defaultSAL6020_R01Filter,
		SAL6020_R01PastFilter: defaultSAL6020_R01Filter,
		SAL6020_R01List: [],
		selectedSAL6020_R01: undefined,
		SAL6020_R01DetailList: [],
		deletedSAL6020_R01DetailList: [],
		selectedSAL6020_R01DetailList: [],
		originalSAL6020_R01DetailList: [],
		editSAL6020_R01: defaultSAL6020_R01Dto,
		allCount: 0,
		
		columnState: null,
		detailColumnState: null,
		scrollTop: null,
		detailScrollTop: null,
	})),

	
}));
